"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARE_AND_COPY_DIALOG_ID = void 0;
const SHARE_AND_COPY_DIALOG_ID = exports.SHARE_AND_COPY_DIALOG_ID = 'share-and-copy-dialog';
//# sourceMappingURL=constants.js.map